import React from 'react';
import parse, { domToReact, Element, DOMNode } from 'html-react-parser';
import { Typography, TypographyAppearanceVariants, TypographyTagVariants } from '@components/atoms/Typography';

export const useHtmlTransformer = () => {
    return {
        transformHtml: (htmlString: string) => {
            return (
                <div>
                    {parse(htmlString, {
                        replace: (domNode: DOMNode) => {
                            return transformElement(domNode as Element);
                        },
                    })}
                </div>
            );
        },
    };
};

const transformElement = (domNode: Element) => {
    const children = domNode.children ? domToReact(domNode.children as DOMNode[]) : null;

    switch (domNode.name) {
        case 'h1':
            return (
                <Typography
                    tagVariant={TypographyTagVariants.h1}
                    appearanceLevel={TypographyAppearanceVariants.level2}
                    classes="mb-3">
                    {children ? children : <></>}
                </Typography>
            );
        case 'h2':
            return (
                <Typography
                    tagVariant={TypographyTagVariants.h2}
                    appearanceLevel={TypographyAppearanceVariants.level3}
                    classes="pt-2 mb-2">
                    {children ? children : <></>}
                </Typography>
            );
        case 'h3':
            return (
                <Typography
                    tagVariant={TypographyTagVariants.h3}
                    appearanceLevel={TypographyAppearanceVariants.level4}
                    classes="pt-2 mb-2">
                    {children ? children : <></>}
                </Typography>
            );
        case 'h4':
            return (
                <Typography
                    tagVariant={TypographyTagVariants.h4}
                    appearanceLevel={TypographyAppearanceVariants.level5}
                    classes="pt-2 mb-2">
                    {children ? children : <></>}
                </Typography>
            );
        case 'h5':
            return (
                <Typography
                    tagVariant={TypographyTagVariants.h5}
                    appearanceLevel={TypographyAppearanceVariants.level7}
                    classes="pt-2 mb-2">
                    {children ? children : <></>}
                </Typography>
            );
        case 'h6':
            return (
                <Typography
                    tagVariant={TypographyTagVariants.h6}
                    appearanceLevel={TypographyAppearanceVariants.level8}
                    classes="pt-2 mb-2">
                    {children ? children : <></>}
                </Typography>
            );
        case 'p':
            return (
                <Typography tagVariant={TypographyTagVariants.p} color="muted">
                    {children ? children : <></>}
                </Typography>
            );
        default:
            return domNode;
    }
};
